import { t } from '../i18n';
import { escapeHtml } from '../utils/html';

/**
 * 🏢 Corporate pack — visitor check-in sheet (feature: 'checkin'). Shown
 * from the landing/start screen's 🪪 button; main.ts owns the submit
 * (checkinService) and the optional route-to-reception follow-up.
 */
export interface CheckinDraft {
  visitorName: string;
  company: string;
  host: string;
  purpose: string;
}

export class CheckinSheet {
  readonly el: HTMLDivElement;
  private onDone: ((draft: CheckinDraft | null) => void) | null = null;

  constructor() {
    this.el = document.createElement('div');
    this.el.className = 'sheet checkin-sheet hidden';
    this.el.innerHTML = `
      <h2>${escapeHtml(t('chk.title'))}</h2>
      <input class="chk-name" type="text" placeholder="${escapeHtml(t('chk.namePh'))}" />
      <input class="chk-company" type="text" placeholder="${escapeHtml(t('chk.companyPh'))}" />
      <input class="chk-host" type="text" placeholder="${escapeHtml(t('chk.hostPh'))}" />
      <input class="chk-purpose" type="text" placeholder="${escapeHtml(t('chk.purposePh'))}" />
      <div class="sheet-btns">
        <button class="btn primary chk-send">${escapeHtml(t('chk.submit'))}</button>
        <button class="btn ghost chk-cancel">${escapeHtml(t('common.cancel'))}</button>
      </div>`;
    (this.el.querySelector('.chk-send') as HTMLButtonElement).addEventListener('click', () => {
      const name = (this.el.querySelector('.chk-name') as HTMLInputElement).value.trim();
      if (!name) {
        (this.el.querySelector('.chk-name') as HTMLInputElement).focus();
        return;
      }
      this.finish({
        visitorName: name,
        company: (this.el.querySelector('.chk-company') as HTMLInputElement).value.trim(),
        host: (this.el.querySelector('.chk-host') as HTMLInputElement).value.trim(),
        purpose: (this.el.querySelector('.chk-purpose') as HTMLInputElement).value.trim(),
      });
    });
    (this.el.querySelector('.chk-cancel') as HTMLButtonElement).addEventListener('click', () =>
      this.finish(null),
    );
  }

  show(onDone: (draft: CheckinDraft | null) => void): void {
    this.onDone = onDone;
    (this.el.querySelector('.chk-name') as HTMLInputElement).value = '';
    this.el.classList.remove('hidden');
  }

  private finish(draft: CheckinDraft | null): void {
    this.el.classList.add('hidden');
    const cb = this.onDone;
    this.onDone = null;
    cb?.(draft);
  }
}
